
class Investors{

	constructor() {

		let bannerNewsletter = document.querySelector('.banner-newsletter');
		if( bannerNewsletter ){

			ScrollTrigger.create({
				start: "top -100",
				endTrigger: ".footer-main",
				end: "top bottom",
				toggleClass: {
					className: 'banner-newsletter--visible',
					targets: bannerNewsletter
				}
			});

		}

		let footerNewsletter = document.querySelector('.newsletter-legals .newsletter');
		if( footerNewsletter ){

			const svg = footerNewsletter.querySelector('.svg path');
			let tl = gsap.timeline({
				'paused' : true
			});
			tl.to( svg, 0.6, {
				drawSVG: '100% 100%',
				ease: Power3.easeIn
			});
			tl.to( svg, 0, {
				drawSVG: '0% 0%'
			}, 0.6);
			tl.to( svg, 0.6, {
				drawSVG: '0% 100%',
				ease: Power3.easeIn
			}, 0.6);

			footerNewsletter.addEventListener('mouseenter', () => {
				tl.restart();
			});

		}

	}

}